export const ERROR_TIMEOUT_DELAY = Number(process.env.ERROR_TIMEOUT_DELAY || 60000);



// WEBPACK FOOTER //
// ./client/utils/api.js